// Smooth Scroll when clicking on calculate
document.querySelector('.calculate-button').addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });


document.querySelector("#calendar-controll-next").addEventListener('click', function(){
    if(document.querySelector(".calendar.active").nextElementSibling && document.querySelector(".calendar.active").nextElementSibling.classList.contains("next")){
        if(document.querySelector(".calendar.prev")){
            document.querySelector(".calendar.prev").classList.remove("prev")
        }
    document.querySelector(".calendar.active").classList.replace("active","prev")
    
    if(document.querySelector(".calendar.next").nextElementSibling){
        document.querySelector(".calendar.next").nextElementSibling.classList.add("next")
    }
document.querySelector(".calendar.next").classList.replace("next", "active")
}
})

document.querySelector("#calendar-controll-prev").addEventListener('click', function(){
    if(document.querySelector(".calendar.active").previousElementSibling && document.querySelector(".calendar.active").previousElementSibling.classList.contains("prev")){
        if(document.querySelector(".calendar.next")){
            document.querySelector(".calendar.next").classList.remove("next")
        }
    document.querySelector(".calendar.active").classList.replace("active","next")
    document.querySelector(".calendar.prev").classList.replace("prev", "active")
    if(document.querySelector(".calendar.active").previousElementSibling){
        document.querySelector(".calendar.active").previousElementSibling.classList.add("prev")
    }
    }
    })


function BerechneZyklus(){
    const datePickerValue = document.querySelector("#date-picker").value
    const dayInMs = 86400000;
    const months = 7;
    const zyklusLaenge = document.querySelector("#zyklus-laenge").value;
    const startDate = new Date(datePickerValue);
    
    var month = startDate.getMonth() + 1 
    if(month < 10){
        month = "0" + month.toString();
    }
    var year = startDate.getFullYear()
    startDate.setHours(0,0,0)
    const startDateInMs = startDate.getTime(); 
    var eisprung = ((zyklusLaenge / 2) - 1) ;
    eisprung = Math.round(eisprung)
    const fruchtbarBeginn = eisprung - 4;
    const sehrFruchtbarBeginn = eisprung - 1;
    if(document.querySelector(".day-content.zyklus")){
      document.querySelectorAll(".day-content").forEach(ele => {
        if(ele.classList.contains("zyklus")){
        ele.classList.remove("zyklus")
    }
    if(ele.classList.contains("ovulation")){
        ele.classList.remove("ovulation")
    }
    if(ele.classList.contains("very")){
        ele.classList.remove("very")
    }
    if(ele.classList.contains("fruitful")){
        ele.classList.remove("fruitful")
    }
    }
    
        );  
    }
    
    for(let i=0;i<months;i++){
        // Berechnen des Beginn des Zyklus
        var zyklusDate = new Date((startDateInMs) + ((zyklusLaenge * dayInMs) * i));
        zyklusDate.setHours(0,0,0); //Remove Timezone offset
        const zyklusDateInMs = zyklusDate.getTime();
        // Berechnen des Eisprungs
        var eisprungDate = new Date(zyklusDateInMs + ((eisprung * dayInMs)))
        eisprungDate.setHours(0,0,0);//Remove Timezone offset
        const eisprungDateInMs = eisprungDate.getTime();
        // Berechnen sehr Fruchtbar
        var sehrFruchtbarDate =  new Date(zyklusDateInMs + ((sehrFruchtbarBeginn * dayInMs)))
        sehrFruchtbarDate.setHours(0,0,0); //Remove Timezone offset
        const sehrFruchtbarDateInMs = sehrFruchtbarDate.getTime()
        
        // markieren des Zyklusbeginns
        document.querySelectorAll(".date-"+(zyklusDateInMs)).forEach(ele => 
            ele.classList.add("zyklus"));
        
            // markieren des Eisprungs
        document.querySelectorAll(".date-"+(eisprungDateInMs)).forEach(ele => 
            ele.classList.add("ovulation","very"));
        
        // markieren der fruchbaren Tage
        for(j=0;j<=5;j++){
            var fruchtbarDate = new Date(zyklusDateInMs + ((fruchtbarBeginn * dayInMs) + (j * dayInMs)))
            fruchtbarDate.setHours(0,0,0) //remove Timezone offset
            const fruchtbarDateInMs = fruchtbarDate.getTime();
            document.querySelectorAll(".date-"+(fruchtbarDateInMs)).forEach(ele => 
                ele.classList.add("fruitful"));
        }
            //markieren sehr fruchtbar beginn
        document.querySelectorAll(".date-"+(sehrFruchtbarDateInMs)).forEach(ele => 
            ele.classList.add("very"));

            if(document.querySelector(".calendar.active") && document.querySelector(".calendar-"+month+"-"+year)){
                document.querySelector(".calendar.active").classList.remove("active")
                if(document.querySelector(".calendar.prev")){
               document.querySelector(".calendar.prev").classList.remove("prev")
            }
                if(document.querySelector(".calendar.next")){
                document.querySelector(".calendar.next").classList.remove("next")
             }



            }
            
            
            
             console.log(month,year)
            if(document.querySelector(".calendar-"+month+"-"+year)){
                document.querySelector(".calendar-"+month+"-"+year).classList.add("active")
            
            if(document.querySelector(".calendar.active").previousElementSibling){
                document.querySelector(".calendar.active").previousElementSibling.classList.add("prev")
            }
            if(document.querySelector(".calendar.active").nextElementSibling){
                document.querySelector(".calendar.active").nextElementSibling.classList.add("next")
            }
            }
            
   }
    
}